import React from "react";
import { BlockContainer, InnerBlockContainer, ContentContainer } from "BaseComponents/Wrappers";
import { H2 } from "BaseComponents/Text";
import { FAQItem } from "./FAQItem";
import useBreakpoint from "Hooks/useBreakpoint";

export const FAQBlock = ({ Header, FAQPages }) => {
	let firstColumn = FAQPages.slice(0, Math.round(FAQPages.length / 2));
	let secondColumn = FAQPages.slice(Math.round(FAQPages.length / 2), FAQPages.length);

	return (
		<BlockContainer>
			<InnerBlockContainer>
				{!!Header.length && (
					<H2 margin="0 0 12px 0" textAlign="center">
						{Header}
					</H2>
				)}
				<ContentContainer margin="0 -2rem" padding="1.5rem 0">
					<ContentContainer
						margin="0 0 0 2rem"
						padding="0"
						width="calc(50% - 3rem)"
						flexDirection="column"
					>
						{firstColumn.map((item, key) => (
							<FAQItem
								{...item}
								lastItem={
									key == firstColumn.length - 1 &&
									!useBreakpoint("mobile")
								}
								key={`FAQ-item-${key}`}
							/>
						))}
					</ContentContainer>
					<ContentContainer
						padding="0"
						margin="0 0 0 2rem"
						width="calc(50% - 3rem)"
						flexDirection="column"
					>
						{secondColumn.map((item, key) => (
							<FAQItem
								{...item}
								key={`FAQ2-item-${key}`}
								lastItem={key == secondColumn.length - 1}
							/>
						))}
					</ContentContainer>
				</ContentContainer>
			</InnerBlockContainer>
		</BlockContainer>
	);
};
